import { RenderHtml } from "@components/html";
import { KeyIcon, FlameIcon, DiamondIcon } from "@components/icons/Icons";
import { AffiliateLinksCopy } from "@lib/constants";
import { Col, Collapse, Divider, Layout, Row, Space } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import { useState } from "react";

interface DataProps {
    className?: string;
    attrs: any;
}

const { Panel } = Collapse;

const WeeklyTopTenList = ({ className, attrs }: DataProps) => {
    const css: any = ["covr-weekly-top-ten-list"];

    const activeKeys = attrs?.items.map(item =>
        item.isOpen === true || attrs.allOpen ? `${item.ID}` : null
    );

    const [openPanels, setOpenPanels] = useState<string[]>(activeKeys);

    if (className) {
        css.push(className);
    }

    const onChange = (activePanels) => {
        setOpenPanels(activePanels);
    };

    return (
        <Layout className={css}>
            {attrs?.title
                && <Row className="data-header">
                    <Col className={`mar-bot-30`}>
                        <h2>{attrs.title}</h2>
                    </Col>
                </Row>}
            <Collapse
                expandIconPosition={`end`}
                defaultActiveKey={activeKeys}
                onChange={
                    (e) => onChange(e)
                } ghost>
                {openPanels && attrs.items
                    .map((item: any, index) => (
                        <Panel
                            showArrow={true}
                            header={
                                <div className={`hr ${attrs.countSelect === 'none'
                                    ? 'count-select-none'
                                    : ''}`}>
                                    {!openPanels.includes(`${item.ID}`)
                                        && <img
                                            className="image img-pop animated animatedFadeInUp fadeInUp"
                                            width={`40`}
                                            src={item.image.src} alt={`small preview`}
                                        />
                                    }
                                    <sup className="hash">#</sup>
                                    <span className="index">
                                        {
                                            attrs.countSelect === 0
                                                ? attrs.items.length - index
                                                : attrs.countSelect === 'up'
                                                    ? attrs.startCountFrom + index
                                                    : attrs.startCountFrom - index
                                        }
                                    </span>
                                    <Paragraph title={item.title}
                                        ellipsis={{
                                            rows: 1,
                                            expandable: false,
                                            symbol: '...',
                                        }}>

                                        <span className="panel-title"> <span className={`dash`}>-</span> {item.title}</span>

                                    </Paragraph>
                                </div>
                            } key={item.ID}>
                            <Row className="wrap" id={`issue-${item.ID}`} gutter={15}>
                                <Col lg={8} md={24} sm={24} className="col" >
                                    {item?.image?.src
                                        && <a
                                            className={`cover-art book-cover animated animatedFadeInUp fadeInUp`}
                                            href={item.link.url}
                                            title={item.title}
                                        >
                                            <img
                                                style={{
                                                    aspectRatio: attrs?.cta?.ratio === 'none'
                                                        ? 'auto'
                                                        : attrs?.cta?.ratio
                                                }}
                                                className="image w-100"
                                                src={item.image.src} alt={``}
                                            />
                                        </a>
                                    }
                                    {
                                        (
                                            item?.affiliateUrls?.ebayUrl ||
                                            item?.affiliateUrls?.mycomicshopUrl
                                        )
                                        && <Space className={`referral-urls`} align="center" size={[5, 5]}>
                                            {item?.affiliateUrls?.ebayUrl
                                                && <a
                                                    className={`btn-sm btn-link`}
                                                    href={item.affiliateUrls.ebayUrl}
                                                    target="_blank" rel="noreferrer"
                                                >
                                                    {AffiliateLinksCopy.EBAY}
                                                </a>
                                            }
                                            <Divider type={`vertical`} />
                                            {item?.affiliateUrls?.mycomicshopUrl
                                                && <a
                                                    className={`btn-sm btn-link`}
                                                    href={item.affiliateUrls.mycomicshopUrl}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {AffiliateLinksCopy.MCS}
                                                </a>
                                            }
                                        </Space>}
                                </Col>
                                <Col lg={16} md={24} sm={24} className="col">
                                    {item?.title
                                        && <a href={item.link.url} title={item.title}>
                                            <h3 className="title">{item.title}</h3>
                                        </a>}
                                    {item?.topLists?.length > 0
                                        &&
                                        <small className="subtitle">Variant Info</small>

                                    }
                                    {item?.topLists?.length > 0
                                        &&
                                        <Row className="types">
                                            <Col span={24} className="valueBadges">
                                                <Space size={[5, 5]}>
                                                    {item.topLists.includes('keyComic')
                                                        && (
                                                            <div className="valueBadge keyIssue isActive">
                                                                <KeyIcon width={42} />
                                                            </div>
                                                        )}
                                                    {item.topLists.includes('hotComic')
                                                        && (<div className="valueBadge hotIssue isActive">
                                                            <FlameIcon />
                                                        </div>)}
                                                    {item.topLists.includes('rareFind')
                                                        && (<div className="valueBadge rareIssue isActive">
                                                            <DiamondIcon />
                                                        </div>)}
                                                </Space>
                                            </Col>
                                        </Row>
                                    }
                                    <div className="grid-stats">
                                        {item?.weeklyData?.value
                                            && <div className="stats stats-1">
                                                Top Weekly Sales
                                                <strong>${item.weeklyData.value}</strong>
                                                {item.weeklyData.certGrade
                                                    && item.weeklyData.certGrade !== ' 0.0'
                                                    && <p>{item.weeklyData.certGrade}</p>}
                                            </div>}
                                        {item?.weeklyData?.unitsSold >= 0
                                            && <div className="stats stats-2">
                                                Weekly Units Sold
                                                <strong>{item.weeklyData.unitsSold}</strong>
                                            </div>}
                                        {item.raw
                                            && <div className="stats stats-3 raw-bg">
                                                Raw | Most Common<br />
                                                <RenderHtml>{item.raw}</RenderHtml>
                                            </div>}
                                        {item?.weeklyData?.trendAvg
                                            && <div className="stats stats-4">
                                                7 Day Trends
                                                <strong>{item.weeklyData.trendAvg}%</strong>
                                            </div>}
                                        {item?.weeklyData?.growth
                                            && <div className="stats stats-4">
                                                Growth
                                                <strong>{item.weeklyData.growth}</strong>
                                            </div>}
                                        {item?.slabbed
                                            && <div className="stats stats-5 slabbed-bg">
                                                Slabbed | Most Common<br />
                                                <RenderHtml>{item.slabbed}</RenderHtml>
                                            </div>}
                                    </div>
                                    {item.description && <RenderHtml>{item.description}</RenderHtml>}
                                    <p className="covr-affiliate-disclosure">Affiliate disclosure: This site contains affiliate links for which we may be compensated.</p>
                                </Col>
                            </Row>
                        </Panel>
                    ))}
            </Collapse>
        </Layout >
    );
};

export default WeeklyTopTenList;


